import { j as s } from "../../jsx-runtime-B6kdoens.js";
import { c as p } from "../../index-CROKJrb5.js";
import { c as m, f as i } from "../../create-component-CBAeEoQ6.js";
const n = p({
  variants: {
    aspectRatio: {
      auto: "cur-aspect-auto",
      square: "cur-aspect-square",
      "1:1": "cur-aspect-square",
      "2:3": "cur-aspect-[2/3]",
      "3:2": "cur-aspect-[3/2]",
      "3:4": "cur-aspect-[3/4]",
      "4:3": "cur-aspect-[4/3]",
      "4:5": "cur-aspect-[4/5]",
      "5:4": "cur-aspect-[5/4]"
    }
  }
}), x = m(
  "Image",
  i(
    ({ as: c, aspectRatio: a = "square", children: e, className: r, ...t }, o) => {
      const u = c || "img";
      return /* @__PURE__ */ s.jsxs("div", { className: n({ aspectRatio: a, className: r }), children: [
        /* @__PURE__ */ s.jsx(
          u,
          {
            ref: o,
            className: "cur-min-h-full cur-min-w-full cur-object-cover",
            ...t
          }
        ),
        e
      ] });
    }
  )
);
export {
  x as Image,
  n as getAspectRatioClasses
};
//# sourceMappingURL=index.js.map
